import {
    LoginState,
    LoginStatus,
    LoginErrorState,
    UserDetails,
} from 'login/store/LoginState';
import { Action } from 'store/store';
import { ResetStateAction, RootActionType } from 'store/rootActions';

export enum LoginActionType {
    LOGIN_STATE_CHANGE = 'LOGIN_STATE_CHANGE',
    LOGIN_STATE_RESET = 'LOGIN_STATE_RESET',
    HAS_AGREED_CHANGE = 'HAS_AGREED_CHANGE',
}

export type LoginStateChangeAction = Action<
    LoginActionType.LOGIN_STATE_CHANGE,
    LoginState
>;

export const loginStateChangeAction: (
    state: LoginState
) => LoginStateChangeAction = (state) => ({
    type: LoginActionType.LOGIN_STATE_CHANGE,
    payload: state,
});
export const loginStatePendingAction = () =>
    loginStateChangeAction({ status: LoginStatus.PENDING });
export const loginStateSuccessAction = (result: UserDetails) =>
    loginStateChangeAction({ status: LoginStatus.SUCCESS, result });

export function isLoginSuccessAction(
    action: unknown
): action is LoginStateChangeAction {
    const loginAction = action as LoginStateChangeAction;
    return (
        loginAction.type === LoginActionType.LOGIN_STATE_CHANGE &&
        loginAction.payload?.status === LoginStatus.SUCCESS
    );
}

export const loginStateErrorAction = (error: LoginErrorState) =>
    loginStateChangeAction({ status: LoginStatus.ERROR, error });

export type LoginResetStateAction = Action<LoginActionType.LOGIN_STATE_RESET>;

export const resetLoginStateAction = (): LoginResetStateAction => ({
    type: LoginActionType.LOGIN_STATE_RESET,
});

export type LoginHasAgreedChangeAction = Action<
    LoginActionType.HAS_AGREED_CHANGE,
    boolean
>;

export const hasAgreedChangeAction = (
    hasAgreed: boolean
): LoginHasAgreedChangeAction => ({
    type: LoginActionType.HAS_AGREED_CHANGE,
    payload: hasAgreed,
});

export function actionAffectsAuthenticationStatus(
    action: LoginAction | ResetStateAction
): boolean {
    return (
        action.type === LoginActionType.LOGIN_STATE_CHANGE ||
        action.type === LoginActionType.LOGIN_STATE_RESET ||
        action.type === RootActionType.RESET_STATE
    );
}

export type LoginAction =
    | LoginStateChangeAction
    | LoginResetStateAction
    | LoginHasAgreedChangeAction;
